import React from 'react';

// eslint-disable-next-line max-len
const SNACKDRAWER_LOGO = '/themes/theme/snackDrawer/logo.png';

const SNACKDRAWERTheme = {
  headerLogo: {
    src: SNACKDRAWER_LOGO,
    alt: 'SNACKDRAWER Logo',
    size: 70,
  },
  darkLogo: {
    src: SNACKDRAWER_LOGO,
    alt: 'SNACKDRAWER Logo',
    size: 70,
  },
  linkStyle: {
    color: '#6c5543',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #6c5543',
    height: 80,
  },
  title: 'Snack Drawer',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="150"
        src={SNACKDRAWER_LOGO} alt="SNACKDRAWER Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.snackdrawer.com',
};

export default SNACKDRAWERTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/snackDrawer.js
 **/